import { render, staticRenderFns } from "./ResourcesList.vue?vue&type=template&id=ef48b87c&scoped=true"
import script from "./ResourcesList.vue?vue&type=script&lang=js"
export * from "./ResourcesList.vue?vue&type=script&lang=js"
import style0 from "./ResourcesList.vue?vue&type=style&index=0&id=ef48b87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef48b87c",
  null
  
)

export default component.exports